<template>
  <v-layout
    align-center
    justify-center
  >
    <v-flex
      xs12
      sm10
      md9
      lg8
    >
      <app-loader
        title="Загрузка данных Новой поставки"
        :loading="!pageLoaded"
      />

      <v-layout
        v-show="pageLoaded"
        align-center
      >
        <v-flex
          xs1
          class="text-xs-center"
        >
          <v-btn
            flat
            large
            icon
            @click="stepper = prevStep"
          >
            <v-icon
              x-large
              color="primary"
            >
              keyboard_arrow_left
            </v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs10>
          <v-layout>
            <h1 class="headline mb-2">
              Новая поставка
            </h1>
          </v-layout>
          <v-card class="elevation-0">
            <v-card-text class="pa-0">
              <v-form
                v-if="entity"
                v-model="isValid"
                @input="handleEntityChange"
              >
                <v-stepper
                  v-model="stepper"
                  class="pa-0 elevation-0"
                >
                  <v-stepper-header class="mb-2">
                    <v-stepper-step
                      :complete="stepper > 1"
                      step="1"
                      editable
                      class="px-2 py-0"
                      @click="stepper = 1"
                    >
                      {{ stepTitles[0] }}
                    </v-stepper-step>

                    <v-divider class="ma-0" />

                    <v-stepper-step
                      :complete="stepper > 2"
                      step="2"
                      editable
                      class="px-2 py-0"
                      @click="stepper = 2"
                    >
                      {{ stepTitles[1] }}
                    </v-stepper-step>

                    <v-divider class="ma-0" />

                    <v-stepper-step
                      :complete="stepper > 3"
                      step="3"
                      editable
                      class="px-2 py-0"
                      @click="stepper = 3"
                    >
                      {{ stepTitles[2] }}
                    </v-stepper-step>

                    <v-divider class="ma-0" />

                    <v-stepper-step
                      :complete="stepper > 4"
                      step="4"
                      editable
                      class="px-2 py-0"
                      @click="stepper = 4"
                    >
                      {{ stepTitles[3] }}
                    </v-stepper-step>

                    <v-divider class="ma-0" />

                    <v-stepper-step
                      step="5"
                      editable
                      class="px-2 py-0"
                      @click="stepper = 5"
                    >
                      {{ stepTitles[4] }}
                    </v-stepper-step>
                  </v-stepper-header>

                  <v-stepper-items
                    id="scroll-target"
                    class="mx-1 mt-4 mb-3 scroll-y"
                    :style="{
                      height: `${blockHeight + 'px'}`,
                      'overflow-y': 'auto'
                    }"
                  >
                    <v-stepper-content
                      step="1"
                      class="pa-0"
                    >
                      <h2 class="mx-2 stepper-title">
                        Основные данные по Поставке
                      </h2>
                      <v-layout column>
                        <v-flex>
                          <app-reference
                            v-if="!allowVisible"
                            v-model="entity.Client"
                            :outline="true"
                            class="mx-2 my-2"
                            label="Клиент*"
                            :disabled="isClient"
                            :rules="[v => !!v || '']"
                            :height-field="44"
                            resource="clients"
                            component-name="Client"
                            @input="clientChanged"
                          />
                        </v-flex>
                        <v-flex>
                          <ManagerSelect
                            v-if="!allowVisible"
                            v-model="entity.Manager"
                            label="Менеджер*"
                            :rules="[v => !!v || '']"
                            :disabled="!entity.Client"
                            class="mx-2 my-2"
                          />
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>

                    <v-stepper-content
                      step="2"
                      class="pa-0"
                    >
                      <h2 class="mx-2 stepper-title">
                        Первоначальное местонахождение груза
                      </h2>
                      <v-layout column>
                        <v-flex xs6>
                          <app-reference
                            v-model="entity.SenderFactory"
                            :outline="true"
                            class="mx-2 my-0"
                            label="Продавец*"
                            resource="factories"
                            component-name="Factory"
                            parent-filter="countryId"
                            :parent-id="entity.Country ? entity.Country.id : 0"
                            :without-parent-lock="true"
                            :height-field="44"
                            :rules="[v => !!v || '']"
                            @handleEntityChange="handleEntityChange"
                          />
                        </v-flex>
                        <v-flex>
                          <v-radio-group
                            v-model="senderType"
                            hide-details
                            row
                            height="25"
                            class="my-3 mx-3"
                            @change="senderTypeChanged"
                          >
                            <h2 class="subheading mr-2">
                              Место отгрузки:
                            </h2>
                            <v-radio
                              v-for="(item, value) in senderTypeItems"
                              :key="value"
                              :label="item.text"
                              :value="item.value"
                            />
                          </v-radio-group>
                        </v-flex>

                        <SenderFactory
                          v-if="senderType === unloadingPlaceTypes.FACTORY"
                          :entity="entity"
                          :sender-factory="entity.SenderFactory"
                          :loading="id && entity.LoadingPlace ? true : false"
                          :changed-sender-type="isChangedSenderType"
                          @handleEntityChange="handleEntityChange"
                        />

                        <SenderWarehouse
                          v-if="
                            senderType === unloadingPlaceTypes.GROUPEDWAREHOUSE
                          "
                          :entity="entity"
                          warehouse-mode="groupedWarehouse"
                          :changed-sender-type="isChangedSenderType"
                          @handleEntityChange="handleEntityChange"
                        />

                        <SenderAddress
                          v-if="senderType === unloadingPlaceTypes.ADDRESS"
                          :entity="entity"
                          :changed-sender-type="isChangedSenderType"
                          @handleEntityChange="handleEntityChange"
                        />

                        <SenderWarehouse
                          v-if="
                            senderType === unloadingPlaceTypes.OTHERWAREHOUSE
                          "
                          :entity="entity"
                          warehouse-mode="otherWarehouse"
                          :changed-sender-type="isChangedSenderType"
                          @handleEntityChange="handleEntityChange"
                        />
                      </v-layout>
                    </v-stepper-content>

                    <v-stepper-content
                      step="3"
                      class="pa-0"
                    >
                      <h2 class="mx-2 stepper-title">
                        Характеристики товара
                      </h2>
                      <v-layout>
                        <v-flex>
                          <v-layout column>
                            <v-layout
                              align-end
                              class="my-2"
                            >
                              <v-flex xs4>
                                <app-date-picker
                                  v-model="entity.ReadyDate"
                                  :outline="true"
                                  class="mx-2 my-0"
                                  label="Дата готовности к отгрузке*"
                                  :height-field="44"
                                  @input="checkValidWantedDate"
                                />
                              </v-flex>
                              <v-flex xs4>
                                <DateRangePicker
                                  v-model="wantedDates"
                                  :outline="true"
                                  label="Желаемая дата доставки к месту выгрузки*"
                                  class="mx-2 my-0"
                                  :without-initial-data="true"
                                  :rules="[
                                    v => !!v || '',
                                    v => isAfterReadyDate || ''
                                  ]"
                                  :error="error"
                                  :min="minDate"
                                  :height-field="44"
                                  :clearable="true"
                                  @input="checkValidWantedDate"
                                />
                              </v-flex>
                              <v-flex xs4>
                                <app-date-picker
                                  v-model="entity.FactoryClosingRequestDate"
                                  :outline="true"
                                  class="mx-2 my-0"
                                  label="Дата закрытия фабрики"
                                  :height-field="44"
                                  :clearable="true"
                                  @input="handleEntityChange"
                                />
                              </v-flex>
                            </v-layout>
                            <v-layout
                              align-end
                              class="my-2"
                            >
                              <v-flex xs4>
                                <v-text-field
                                  v-model="entity.InternalRequestNumber"
                                  outline
                                  class="mx-2"
                                  label="Внутренний номер заявки у клиента, если он использует собственную нумерацию заявок"
                                  hide-details
                                  height="44"
                                  @input="handleEntityChange"
                                />
                              </v-flex>
                              <v-flex xs4>
                                <v-text-field
                                  v-model="entity.CommentForShipping"
                                  outline
                                  class="mx-2 my-0"
                                  label="Комментарии к поставке"
                                  hide-details
                                  height="44"
                                />
                              </v-flex>
                              <v-flex xs4>
                                <v-text-field
                                  v-model="entity.ProductDescription"
                                  outline
                                  class="mx-2"
                                  label="Описание товара"
                                  hide-details
                                  height="44"
                                  @input="handleEntityChange"
                                />
                              </v-flex>
                            </v-layout>
                            <v-layout
                              align-end
                              class="my-2"
                            >
                              <v-flex>
                                <DecimalEditor
                                  v-model="entity.Weight"
                                  class="mx-2"
                                  label="Вес брутто, кг*"
                                  :scale="3"
                                  :rules="[v => !!v || '']"
                                  :outline="true"
                                  :height-field="44"
                                />
                              </v-flex>
                              <v-flex>
                                <DecimalEditor
                                  v-model="entity.Volume"
                                  class="mx-2"
                                  label="Объем, м3*"
                                  :scale="3"
                                  :rules="[v => !!v || '']"
                                  :available-zero="true"
                                  :outline="true"
                                  :height-field="44"
                                />
                              </v-flex>
                              <v-flex>
                                <DecimalEditor
                                  v-model="entity.InvoiceSum"
                                  class="mx-2"
                                  label="Стоимость партии груза*"
                                  :scale="2"
                                  :rules="[
                                    v => !!v || 'Поле обязательно к заполнению'
                                  ]"
                                  :outline="true"
                                  :height-field="44"
                                />
                              </v-flex>
                              <v-flex>
                                <app-reference
                                  v-model="entity.Currency"
                                  :outline="true"
                                  class="mx-2"
                                  label="Валюта*"
                                  :rules="[v => !!v || '']"
                                  :height-field="44"
                                  resource="currencies"
                                  component-name="Currency"
                                />
                              </v-flex>
                            </v-layout>
                            <v-layout
                              align-end
                              class="my-2"
                            >
                              <v-flex xs9>
                                <EnumSelect
                                  v-model="entity.NeedEx"
                                  :outline="true"
                                  :without-selected="false"
                                  :return-object="true"
                                  :height-field="44"
                                  label="Нужна ли Ex"
                                  resource="need-ex-types"
                                  class="mx-2"
                                  @input="handleEntityChange"
                                />
                              </v-flex>
                              <!-- Доп инфо о товаре -->
                              <v-flex xs3>
                                <v-btn
                                  small
                                  class="mb-0 mt-3"
                                  @click="attachmentDialog = true"
                                >
                                  {{
                                    `Документы (${newAttachments.length +
                                      newAttachmentsForExport.length})`
                                  }}
                                </v-btn>
                              </v-flex>
                            </v-layout>
                            <v-layout
                              align-end
                              class="my-2"
                            >
                              <v-flex>
                                <LabelSelectSimple
                                  v-model="entity.ParseByOrders"
                                  class="mx-2"
                                  title="Разобрать по ордерам"
                                  @change="handleEntityChange"
                                />
                              </v-flex>
                              <v-flex>
                                <LabelSelectSimple
                                  v-model="entity.IsPayed"
                                  class="mx-2"
                                  title="Груз оплачен"
                                  @change="handleEntityChange"
                                />
                              </v-flex>
                              <v-flex>
                                <LabelSelectComplex
                                  v-model="entity.Urgency"
                                  class="mx-2"
                                  title="Срочность"
                                  :items="[
                                    { id: 0, title: 'Стандартная' },
                                    { id: 1, title: 'Срочная' }
                                  ]"
                                  :colors="['green', 'red']"
                                  @change="handleEntityChange"
                                />
                              </v-flex>
                              <v-flex>
                                <v-tooltip top>
                                  <template slot="activator">
                                    <LabelSelectSimple
                                      v-model="entity.Oversized"
                                      class="mx-2"
                                      title="Негабарит"
                                      true-color="red"
                                      false-color="green"
                                      :readonly="true"
                                      @change="handleEntityChange"
                                    />
                                  </template>
                                  <span>Сторона больше 2,4 м</span>
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                            <v-layout
                              column
                              class="my-2"
                            >
                              <v-flex>
                                <Packages
                                  v-model="entity.Packages"
                                  :scroll-value="scrollValue"
                                  :is-shipping="true"
                                  @change="changePackages"
                                />
                              </v-flex>
                              <v-flex>
                                <v-textarea
                                  v-model="entity.CargoComment"
                                  outline
                                  class="ma-2"
                                  label="Комментарии к размерам и кол-ву грузовых мест"
                                  rows="1"
                                  auto-grow
                                  hide-details
                                />
                              </v-flex>
                            </v-layout>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>

                    <v-stepper-content
                      step="4"
                      class="pa-0"
                    >
                      <h2 class="mx-2 stepper-title">
                        Адрес доставки товара
                      </h2>
                      <v-layout>
                        <v-flex>
                          <v-layout column>
                            <v-layout
                              align-end
                              class="my-2"
                            >
                              <v-flex>
                                <EnumSelect
                                  v-model="entity.ShippingType"
                                  :outline="true"
                                  :rules="[v => !!v || v == 0 || '']"
                                  :without-selected="false"
                                  :return-object="true"
                                  :height-field="44"
                                  :clearable="false"
                                  label="Тип поставки*"
                                  resource="delivery-types"
                                  class="mx-2 my-0"
                                  @input="shippingTypeChanged"
                                />
                              </v-flex>
                              <v-flex>
                                <app-reference
                                  v-model="entity.DestinationCountry"
                                  :outline="true"
                                  class="mx-2 my-0"
                                  label="Страна получателя по докам фабрики/отправителя*"
                                  :rules="[v => !!v || '']"
                                  :height-field="44"
                                  resource="countries/ukraine-first"
                                  component-name="Country"
                                  @input="shippingTypeChanged"
                                />
                              </v-flex>
                              <v-flex>
                                <CountryFilteringReference
                                  v-model="entity.UnloadingCountry"
                                  :rules="[v => !!v || '']"
                                  :height-field="44"
                                  :outline="true"
                                  :disabled="
                                    entity.ShippingType.id ===
                                      shippingTypes.ImportUkraine ||
                                      (entity.ShippingType.id ===
                                        shippingTypes.InsideUkraine &&
                                        entity.UnloadingCountry !== null)
                                  "
                                  :without-ukraine="countryWithoutUkraine"
                                  :clearable="true"
                                  label="Страна выгрузки*"
                                  resource="countries"
                                  component-name="Country"
                                  class="mx-2 my-0"
                                  @input="unloadingCountryChanged"
                                />
                              </v-flex>
                            </v-layout>
                            <v-layout
                              align-end
                              class="my-2"
                            >
                              <v-flex>
                                <app-reference
                                  v-model="entity.UnloadingCity"
                                  :outline="true"
                                  class="mx-2 my-0"
                                  label="Город выгрузки*"
                                  :rules="[v => !!v || '']"
                                  :height-field="44"
                                  resource="cities"
                                  parent-filter="countryId"
                                  :parent-id="
                                    entity.UnloadingCountry
                                      ? entity.UnloadingCountry.id
                                      : 0
                                  "
                                  component-name="City"
                                  @input="entity.UnloadingAddress = ''"
                                />
                              </v-flex>
                              <v-flex>
                                <app-reference
                                  v-model="entity.UnloadingAddress"
                                  :outline="true"
                                  class="mx-2 my-0"
                                  label="Адрес выгрузки*"
                                  :rules="[v => !!v || '']"
                                  :height-field="44"
                                  resource="addresses"
                                  parent-filter="cityId"
                                  :parent-id="
                                    entity.UnloadingCity
                                      ? entity.UnloadingCity.id
                                      : 0
                                  "
                                  component-name="Address"
                                  @input="unloadingAddressChanged"
                                />
                              </v-flex>
                            </v-layout>
                            <UnloadingContacts
                              :value="entity.ContactsUnloading"
                              :scroll-value="scrollValue"
                              :entity-id="entity.Id"
                              :is-our-warehouse="isOurWarehouse"
                              @change="unloadingContactsChanged"
                            />
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>

                    <v-stepper-content
                      step="5"
                      class="pa-0"
                    >
                      <v-layout
                        v-scroll:#scroll-target="onScroll"
                        column
                        style="height: auto"
                      >
                        <v-layout align-end>
                          <h2 class="ml-2">
                            Основные данные по Поставке
                          </h2>
                          <v-btn
                            icon
                            class="my-0"
                          >
                            <v-icon
                              color="grey"
                              @click="stepper = 1"
                            >
                              edit
                            </v-icon>
                          </v-btn>
                        </v-layout>
                        <v-layout column>
                          <v-flex>
                            <app-reference
                              v-if="!allowVisible"
                              v-model="entity.Client"
                              :outline="true"
                              class="mx-2 my-2"
                              label="Клиент*"
                              :disabled="isClient"
                              :rules="[v => !!v || '']"
                              :height-field="44"
                              resource="clients"
                              component-name="Client"
                              :error="checkMissingElement(entity.Client, true)"
                              :scroll-value="scrollValue"
                              @input="clientChanged"
                            />
                          </v-flex>
                          <v-flex>
                            <ManagerSelect
                              v-if="!allowVisible"
                              v-model="entity.Manager"
                              label="Менеджер*"
                              :rules="[v => !!v || '']"
                              class="mx-2 my-2"
                              :error="checkMissingElement(entity.Manager, true)"
                              :scroll-value="scrollValue"
                              :disabled="!entity.Client"
                            />
                          </v-flex>
                        </v-layout>

                        <v-layout
                          align-end
                          class="mt-3"
                        >
                          <h2 class="ml-2 mt-3">
                            Первоначальное местонахождение груза
                          </h2>
                          <v-btn
                            icon
                            class="my-0"
                          >
                            <v-icon
                              color="grey"
                              @click="stepper = 2"
                            >
                              edit
                            </v-icon>
                          </v-btn>
                        </v-layout>
                        <v-layout column>
                          <v-flex xs6>
                            <app-reference
                              v-model="entity.SenderFactory"
                              :outline="true"
                              class="mx-2 my-0"
                              label="Продавец*"
                              resource="factories"
                              component-name="Factory"
                              parent-filter="countryId"
                              :parent-id="
                                entity.Country ? entity.Country.id : 0
                              "
                              :without-parent-lock="true"
                              :height-field="44"
                              :rules="[v => !!v || '']"
                              :error="
                                checkMissingElement(entity.SenderFactory, true)
                              "
                              :scroll-value="scrollValue"
                              @handleEntityChange="handleEntityChange"
                            />
                          </v-flex>
                          <v-flex>
                            <v-radio-group
                              v-model="senderType"
                              hide-details
                              row
                              height="25"
                              class="my-3 mx-3"
                              @change="senderTypeChanged"
                            >
                              <h2 class="subheading mr-2">
                                Место отгрузки:
                              </h2>
                              <v-radio
                                v-for="(item, value) in senderTypeItems"
                                :key="value"
                                :label="item.text"
                                :value="item.value"
                              />
                            </v-radio-group>
                          </v-flex>

                          <SenderFactory
                            v-if="senderType === unloadingPlaceTypes.FACTORY"
                            :entity="entity"
                            :sender-factory="entity.SenderFactory"
                            :is-highlight-label="true"
                            :loading="id && entity.LoadingPlace ? true : false"
                            :changed-sender-type="isChangedSenderType"
                            @handleEntityChange="handleEntityChange"
                          />

                          <SenderWarehouse
                            v-if="
                              senderType ===
                                unloadingPlaceTypes.GROUPEDWAREHOUSE
                            "
                            :entity="entity"
                            :is-highlight-label="true"
                            warehouse-mode="groupedWarehouse"
                            :changed-sender-type="isChangedSenderType"
                            @handleEntityChange="handleEntityChange"
                          />

                          <SenderAddress
                            v-if="senderType === unloadingPlaceTypes.ADDRESS"
                            :entity="entity"
                            :is-highlight-label="true"
                            :changed-sender-type="isChangedSenderType"
                            @handleEntityChange="handleEntityChange"
                          />

                          <SenderWarehouse
                            v-if="
                              senderType === unloadingPlaceTypes.OTHERWAREHOUSE
                            "
                            :entity="entity"
                            :is-highlight-label="true"
                            warehouse-mode="otherWarehouse"
                            :changed-sender-type="isChangedSenderType"
                            @handleEntityChange="handleEntityChange"
                          />
                        </v-layout>

                        <v-layout
                          align-end
                          class="mt-3"
                        >
                          <h2 class="ml-2 mt-3">
                            Характеристики товара
                          </h2>
                          <v-btn
                            icon
                            class="my-0"
                          >
                            <v-icon
                              color="grey"
                              @click="stepper = 3"
                            >
                              edit
                            </v-icon>
                          </v-btn>
                        </v-layout>
                        <v-layout>
                          <v-flex>
                            <v-layout column>
                              <v-layout
                                align-end
                                class="my-2"
                              >
                                <v-flex xs4>
                                  <app-date-picker
                                    v-model="entity.ReadyDate"
                                    :outline="true"
                                    class="mx-2 my-0"
                                    label="Дата готовности к отгрузке*"
                                    :height-field="44"
                                    :error="
                                      checkMissingElement(
                                        entity.ReadyDate,
                                        true
                                      )
                                    "
                                    :scroll-value="scrollValue"
                                    @input="checkValidWantedDate"
                                  />
                                </v-flex>
                                <v-flex xs4>
                                  <DateRangePicker
                                    v-model="wantedDates"
                                    :outline="true"
                                    label="Желаемая дата доставки к месту выгрузки*"
                                    class="mx-2 my-0"
                                    :without-initial-data="true"
                                    :rules="[
                                      v => !!v || '',
                                      v => isAfterReadyDate || ''
                                    ]"
                                    :class="checkMissingElement(wantedDates)"
                                    :min="minDate"
                                    :height-field="44"
                                    :clearable="true"
                                    prepend-icon="event"
                                    :scroll-value="scrollValue"
                                    @input="checkValidWantedDate"
                                  />
                                </v-flex>
                                <v-flex xs4>
                                  <app-date-picker
                                    v-model="entity.FactoryClosingRequestDate"
                                    :outline="true"
                                    class="mx-2 my-0"
                                    label="Дата закрытия фабрики"
                                    :height-field="44"
                                    :clearable="true"
                                    @input="handleEntityChange"
                                  />
                                </v-flex>
                              </v-layout>
                              <v-layout
                                align-end
                                class="my-2"
                              >
                                <v-flex xs4>
                                  <v-text-field
                                    v-model="entity.InternalRequestNumber"
                                    outline
                                    class="mx-2"
                                    label="Внутренний номер заявки у клиента, если он использует собственную нумерацию заявок"
                                    hide-details
                                    height="44"
                                    @input="handleEntityChange"
                                  />
                                </v-flex>
                                <v-flex xs4>
                                  <v-text-field
                                    v-model="entity.CommentForShipping"
                                    outline
                                    class="mx-2 my-0"
                                    label="Комментарии к поставке"
                                    hide-details
                                    height="44"
                                  />
                                </v-flex>
                                <v-flex xs4>
                                  <v-text-field
                                    v-model="entity.ProductDescription"
                                    outline
                                    class="mx-2"
                                    label="Описание товара"
                                    hide-details
                                    height="44"
                                    @input="handleEntityChange"
                                  />
                                </v-flex>
                              </v-layout>
                              <v-layout />
                              <v-layout
                                align-end
                                class="my-2"
                              >
                                <v-flex>
                                  <DecimalEditor
                                    v-model="entity.Weight"
                                    class="mx-2"
                                    label="Вес брутто, кг*"
                                    :scale="3"
                                    :rules="[v => !!v || '']"
                                    :outline="true"
                                    :height-field="44"
                                    :error="
                                      checkMissingElement(entity.Weight, true)
                                    "
                                  />
                                </v-flex>
                                <v-flex>
                                  <DecimalEditor
                                    v-model="entity.Volume"
                                    class="mx-2"
                                    label="Объем, м3*"
                                    :scale="3"
                                    :rules="[v => !!v || '']"
                                    :available-zero="true"
                                    :outline="true"
                                    :height-field="44"
                                    :error="
                                      checkMissingVolume(entity.Volume, true)
                                    "
                                  />
                                </v-flex>
                                <v-flex>
                                  <DecimalEditor
                                    v-model="entity.InvoiceSum"
                                    class="mx-2"
                                    label="Стоимость партии груза*"
                                    :scale="2"
                                    :rules="[
                                      v =>
                                        !!v || 'Поле обязательно к заполнению'
                                    ]"
                                    :outline="true"
                                    :height-field="44"
                                    :error="
                                      checkMissingElement(
                                        entity.InvoiceSum,
                                        true
                                      )
                                    "
                                  />
                                </v-flex>
                                <v-flex>
                                  <app-reference
                                    v-model="entity.Currency"
                                    :outline="true"
                                    class="mx-2"
                                    label="Валюта*"
                                    :rules="[v => !!v || '']"
                                    :height-field="44"
                                    resource="currencies"
                                    component-name="Currency"
                                    :scroll-value="scrollValue"
                                    :error="
                                      checkMissingElement(entity.Currency, true)
                                    "
                                  />
                                </v-flex>
                              </v-layout>
                              <v-layout
                                align-end
                                class="my-2"
                              >
                                <v-flex xs9>
                                  <EnumSelect
                                    v-model="entity.NeedEx"
                                    :outline="true"
                                    :without-selected="false"
                                    :return-object="true"
                                    :height-field="44"
                                    label="Нужна ли Ex"
                                    resource="need-ex-types"
                                    :scroll-value="scrollValue"
                                    class="mx-2"
                                    @input="handleEntityChange"
                                  />
                                </v-flex>
                                <!-- Доп инфо о товаре -->
                                <v-flex xs3>
                                  <v-btn
                                    small
                                    class="mb-0 mt-3"
                                    @click="attachmentDialog = true"
                                  >
                                    {{
                                      `Документы (${newAttachments.length +
                                        newAttachmentsForExport.length})`
                                    }}
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                              <v-layout
                                align-end
                                class="my-2"
                              >
                                <v-flex>
                                  <LabelSelectSimple
                                    v-model="entity.ParseByOrders"
                                    class="mx-2"
                                    title="Разобрать по ордерам"
                                    :scroll-value="scrollValue"
                                    @change="handleEntityChange"
                                  />
                                </v-flex>
                                <v-flex>
                                  <LabelSelectSimple
                                    v-model="entity.IsPayed"
                                    class="mx-2"
                                    title="Груз оплачен"
                                    :scroll-value="scrollValue"
                                    @change="handleEntityChange"
                                  />
                                </v-flex>
                                <v-flex>
                                  <LabelSelectComplex
                                    v-model="entity.Urgency"
                                    class="mx-2"
                                    title="Срочность"
                                    :items="[
                                      { id: 0, title: 'Стандартная' },
                                      { id: 1, title: 'Срочная' }
                                    ]"
                                    :colors="['green', 'red']"
                                    :scroll-value="scrollValue"
                                    @change="handleEntityChange"
                                  />
                                </v-flex>
                                <v-flex>
                                  <v-tooltip top>
                                    <template slot="activator">
                                      <LabelSelectSimple
                                        v-model="entity.Oversized"
                                        class="mx-2"
                                        title="Негабарит"
                                        true-color="red"
                                        false-color="green"
                                        :scroll-value="scrollValue"
                                        :readonly="true"
                                        @change="handleEntityChange"
                                      />
                                    </template>
                                    <span>Сторона больше 2,4 м</span>
                                  </v-tooltip>
                                </v-flex>
                              </v-layout>
                              <v-layout
                                column
                                class="my-2"
                              >
                                <v-flex>
                                  <Packages
                                    v-model="entity.Packages"
                                    :indicate-of-missing-value="true"
                                    :scroll-value="scrollValue"
                                    :is-shipping="true"
                                    @change="changePackages"
                                  />
                                </v-flex>
                                <v-flex>
                                  <v-textarea
                                    v-model="entity.CargoComment"
                                    outline
                                    class="ma-2"
                                    label="Комментарии к размерам и кол-ву грузовых мест"
                                    rows="1"
                                    auto-grow
                                    hide-details
                                  />
                                </v-flex>
                              </v-layout>
                            </v-layout>
                          </v-flex>
                        </v-layout>

                        <v-layout
                          align-end
                          class="mt-3"
                        >
                          <h2 class="ml-2 mt-3">
                            Адрес доставки товара
                          </h2>
                          <v-btn
                            icon
                            class="my-0"
                          >
                            <v-icon
                              color="grey"
                              @click="stepper = 4"
                            >
                              edit
                            </v-icon>
                          </v-btn>
                        </v-layout>
                        <v-layout>
                          <v-flex>
                            <v-layout column>
                              <v-layout
                                align-end
                                class="my-2"
                              >
                                <v-flex>
                                  <EnumSelect
                                    v-model="entity.ShippingType"
                                    :outline="true"
                                    :rules="[v => !!v || v == 0 || '']"
                                    :without-selected="false"
                                    :return-object="true"
                                    :height-field="44"
                                    :clearable="false"
                                    label="Тип поставки*"
                                    resource="delivery-types"
                                    :scroll-value="scrollValue"
                                    class="mx-2 my-0"
                                    @input="shippingTypeChanged"
                                  />
                                </v-flex>
                                <v-flex>
                                  <app-reference
                                    v-model="entity.DestinationCountry"
                                    :outline="true"
                                    class="mx-2 my-0"
                                    label="Страна получателя по докам фабрики/отправителя*"
                                    :rules="[v => !!v || '']"
                                    :height-field="44"
                                    resource="countries/ukraine-first"
                                    component-name="Country"
                                    :error="
                                      checkMissingElement(
                                        entity.DestinationCountry,
                                        true
                                      )
                                    "
                                    :scroll-value="scrollValue"
                                    @input="shippingTypeChanged"
                                  />
                                </v-flex>
                                <v-flex>
                                  <CountryFilteringReference
                                    v-model="entity.UnloadingCountry"
                                    :rules="[v => !!v || '']"
                                    :height-field="44"
                                    :outline="true"
                                    :disabled="
                                      entity.ShippingType.id ===
                                        shippingTypes.ImportUkraine ||
                                        (entity.ShippingType.id ===
                                          shippingTypes.InsideUkraine &&
                                          entity.UnloadingCountry !== null)
                                    "
                                    :without-ukraine="countryWithoutUkraine"
                                    :clearable="true"
                                    label="Страна выгрузки*"
                                    resource="countries"
                                    component-name="Country"
                                    class="mx-2 my-0"
                                    :error="
                                      checkMissingElement(
                                        entity.UnloadingCountry,
                                        true
                                      )
                                    "
                                    :scroll-value="scrollValue"
                                    @input="unloadingCountryChanged"
                                  />
                                </v-flex>
                              </v-layout>
                              <v-layout
                                align-end
                                class="my-2"
                              >
                                <v-flex>
                                  <app-reference
                                    v-model="entity.UnloadingCity"
                                    :outline="true"
                                    class="mx-2 my-0"
                                    label="Город выгрузки*"
                                    :rules="[v => !!v || '']"
                                    :height-field="44"
                                    resource="cities"
                                    parent-filter="countryId"
                                    :parent-id="
                                      entity.UnloadingCountry
                                        ? entity.UnloadingCountry.id
                                        : 0
                                    "
                                    component-name="City"
                                    :error="
                                      checkMissingElement(
                                        entity.UnloadingCity,
                                        true
                                      )
                                    "
                                    :scroll-value="scrollValue"
                                    @input="entity.UnloadingAddress = ''"
                                  />
                                </v-flex>
                                <v-flex>
                                  <app-reference
                                    v-model="entity.UnloadingAddress"
                                    :outline="true"
                                    class="mx-2 my-0"
                                    label="Адрес выгрузки*"
                                    :rules="[v => !!v || '']"
                                    :height-field="44"
                                    resource="addresses"
                                    parent-filter="cityId"
                                    :parent-id="
                                      entity.UnloadingCity
                                        ? entity.UnloadingCity.id
                                        : 0
                                    "
                                    component-name="Address"
                                    :error="
                                      checkMissingElement(
                                        entity.UnloadingAddress,
                                        true
                                      )
                                    "
                                    :scroll-value="scrollValue"
                                    @input="unloadingAddressChanged"
                                  />
                                </v-flex>
                              </v-layout>
                              <UnloadingContacts
                                :value="entity.ContactsUnloading"
                                :scroll-value="scrollValue"
                                :entity-id="entity.Id"
                                :is-our-warehouse="isOurWarehouse"
                                @change="unloadingContactsChanged"
                              />
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn
                small
                class="ma-0"
                color="primary"
                :disabled="
                  !(isValid && isChanged) || loadingSubmit || loadingDraft
                "
                :loading="loadingSubmit"
                @click="submit()"
              >
                Сохранить
              </v-btn>
              <v-btn
                small
                class="my-0 mx-2"
                :disabled="loadingDraft || loadingSubmit"
                :loading="loadingDraft"
                @click="submitDraft()"
              >
                Сохранить черновик
              </v-btn>
              <v-btn
                v-if="isDraft && id && id > 0"
                small
                class="my-0 mx-2"
                color="error"
                :disabled="loadingDraft || loadingSubmit"
                :loading="loadingDeleteDraft"
                @click="deleteDraft()"
              >
                Удалить безвозвратно
              </v-btn>
              <v-spacer />
              <v-btn
                small
                class="ma-0"
                :disabled="loadingDraft || loadingSubmit"
                @click="cancel"
              >
                Отмена
              </v-btn>
            </v-card-actions>
          </v-card>

          <v-card>
            <v-dialog
              v-model="attachmentDialog"
              persistent
              width="500"
            >
              <v-card>
                <v-card-actions>
                  <v-card-title class="subheading font-weight-bold pa-0">
                    Загруженные документы
                  </v-card-title>
                  <v-spacer />
                  <v-btn
                    small
                    style="height: 20px; width: 20px;"
                    fab
                    dark
                    color="grey"
                    icon
                    @click="attachmentDialog = false"
                  >
                    <v-icon
                      small
                      dark
                    >
                      close
                    </v-icon>
                  </v-btn>
                </v-card-actions>
                <v-card-text>
                  <Attachments
                    v-model="newAttachmentsForExport"
                    :block-height="100"
                    :resource="`shipping-drafts/${id}`"
                    :disabled-sender="true"
                    :disabled-upload="false"
                    :disabled-upload-to-server="!isDraft"
                    :disabled-download="true"
                    :type="attachmentsType.EXPORT"
                    title="Экспортные документы"
                    @input="changeAttachmentsForExport"
                  />
                  <v-divider class="mt-2" />
                  <Attachments
                    v-model="newAttachments"
                    :block-height="100"
                    :resource="`shipping-drafts/${id}`"
                    :disabled-sender="true"
                    :disabled-upload="false"
                    :disabled-upload-to-server="!isDraft"
                    :disabled-download="true"
                    title="Другие документы"
                    @input="changeAttachments"
                  />
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-card>
        </v-flex>
        <v-flex
          xs1
          class="text-xs-center"
        >
          <v-btn
            flat
            large
            icon
            @click="stepper = nextStep"
          >
            <v-icon
              x-large
              color="primary"
            >
              keyboard_arrow_right
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import mixin from "../../../../mixins/confirm-cancel-changes.js";
import LabelSelectSimple from "../../../../components/label/LabelSelectSimple.vue";
import LabelSelectComplex from "../../../../components/label/LabelSelectComplex.vue";
import SenderFactory from "./SenderFactory.vue";
import SenderWarehouse from "./SenderWarehouse.vue";
import SenderAddress from "./SenderAddress.vue";
import CountryFilteringReference from "../../../countries/CountryFilteringReference.vue";
import Attachments from "../../../../components/attachments/Attachments.vue";
import auth from "../../../../auth";
import userAccess from "../../user-access.js";
import upload from "../../../../components/attachments/upload.js";
import * as newShippingApi from "../../../../backend/newShippingApi.js";
import {
  getWarehouseReferenceAddress,
  getFactory,
} from "../../../../backend/shippingsApi.js";
import { getUkraine } from "../../../../backend/countriesApi.js";
import { shippingTypes } from "../../shipping-types.js";
import * as clientsApi from "../../../../backend/clientsApi.js";
import { unloadingPlaceTypes } from "../../../../enums/unloading-place-types.js";
import UnloadingContacts from "./UnloadingContacts.vue";
import Packages from "./Packages.vue";
import { attachmentsType } from "../../../../enums/attachments-types.js";

export default {
  components: {
    Attachments,
    LabelSelectSimple,
    LabelSelectComplex,
    SenderFactory,
    SenderWarehouse,
    SenderAddress,
    CountryFilteringReference,
    UnloadingContacts,
    Packages,
  },
  mixins: [mixin, userAccess],
  props: ["id", "isDraft"],
  data() {
    return {
      isValid: false,
      isClient: false,
      entity: null,
      originEntity: null,
      newAttachments: [],
      newAttachmentsForExport: [],
      attachmentDialog: false,
      clientLoading: false,
      sendersLoading: false,
      expandedLoading: false,
      newClientAlias: "",
      ukraine: null,
      isOurWarehouse: false,
      addWarehouseBtnActive: true,
      entityLoaded: false,
      stepper: 0,
      stepTitles: [
        "Основные",
        "Местонахождение",
        "Характеристики",
        "Доставка",
        "Итог",
      ],
      senderType: null,
      error: false,
      wantedDates: null,
      scrollValue: 0,
      loadingSubmit: false,
      loadingDraft: false,
      loadingDeleteDraft: false,
      isChangedSenderType: false,
    };
  },
  computed: {
    pageLoaded() {
      return this.entityLoaded;
    },
    nextStep() {
      if (this.stepper == 1) {
        return 2;
      } else if (this.stepper == this.stepTitles.length) {
        return 1;
      } else {
        return this.stepper + 1;
      }
    },
    prevStep() {
      if (this.stepper == 1) {
        return 5;
      } else {
        return this.stepper - 1;
      }
    },
    blockHeight() {
      return window.innerHeight - 260;
    },
    stepBlockHeight() {
      return this.blockHeight - 100;
    },
    isAfterReadyDate() {
      if (this.wantedDates && this.wantedDates.dateFrom) {
        return this.moment(this.wantedDates.dateFrom).isAfter(
          this.entity.ReadyDate,
        );
      }
    },
    minDate() {
      return this.moment(this.entity.ReadyDate, "YYYY-MM-DD")
        .add(1, "days")
        .format("YYYY-MM-DD");
    },
    countryWithoutUkraine() {
      return (
        this.entity.ShippingType &&
        (this.entity.ShippingType.id === shippingTypes.ExportUkraine ||
          this.entity.ShippingType.id === shippingTypes.OutsideUkraine)
      );
    },
    senderTypeItems() {
      return this.$store.getters["shipping/senderTypeItems"];
    },
    shippingTypes() {
      return shippingTypes;
    },
    unloadingPlaceTypes() {
      return unloadingPlaceTypes;
    },
    attachmentsType() {
      return attachmentsType;
    },
  },
  created() {
    this.isClient = auth.getUser().isClient;
    this.senderType = this.unloadingPlaceTypes?.FACTORY;

    if (this.id && this.id > 0) {
      this.getDraft();
    } else {
      this.getPreparedEntity();
    }
  },
  methods: {
    onScroll(e) {
      this.scrollValue = e.target.scrollTop;
    },
    async getPreparedEntity() {
      const response = await newShippingApi.getNewShipping();
      const newEntity = {};
      for (const key in response) {
        if (key === "ReadyDate") {
          newEntity[key] = null;
        } else if (response[key]) {
          newEntity[key] = response[key].Title
            ? { id: response[key].Id, title: response[key].Title }
            : response[key];
        } else if (key === "UnloadingCountry") {
          this.getNewShippingUkr();
        } else {
          newEntity[key] = response[key];
        }
      }
      this.entity = newEntity;
      this.originEntity = JSON.parse(JSON.stringify(this.entity));
      this.unloadingAddressChanged();
      this.ukraine = await getUkraine();
      this.entityLoaded = true;
    },
    async getDraft() {
      const response = await newShippingApi.getDraftShipping(this.id);
      const newEntity = {};
      for (const key in response) {
        if (Array.isArray(response[key])) {
          newEntity[key] = response[key].length
            ? response[key].map(item => {
              const element = {};
              for (const prop in item) {
                if (typeof item[prop] === "object") {
                  element[
                    `${prop.charAt(0).toLowerCase()}${prop.slice(1)}`
                  ] = item[prop]
                    ? {
                      id: item[prop].Id,
                      title: item[prop].Title,
                    }
                    : null;
                } else {
                  element[`${prop.charAt(0).toLowerCase()}${prop.slice(1)}`] =
                      item[prop];
                }
              }
              return element;
            })
            : [];
        } else if (typeof response[key] === "object" && response[key]) {
          const element = {};
          for (const prop in response[key]) {
            element[`${prop.charAt(0).toLowerCase()}${prop.slice(1)}`] =
              response[key][prop];
          }
          newEntity[key] = element;
        } else {
          newEntity[key] = response[key];
        }
      }
      this.entity = newEntity;

      this.newAttachments = response.Attachments.map(i => {
        return {
          id: i.Id,
          title: i.Title,
        };
      });
      this.newAttachmentsForExport = response.AttachmentsForExport.map(i => {
        return {
          id: i.Id,
          title: i.Title,
        };
      });
      if (this.entity.SenderFactory) {
        const response = await getFactory(this.entity.SenderFactory.id);
        const item = response.LoadingPlaces.find(
          i => i.Address.Id === this.entity.LoadingAddress?.id,
        );
        if (item) {
          this.$set(this.entity, "LoadingPlace", {
            id: item.Id,
            title: item.Address.Title,
          });
        } else {
          this.$set(this.entity, "LoadingPlace", null);
        }
      }
      this.senderType = response.SenderType;
      this.originEntity = JSON.parse(JSON.stringify(this.entity));

      if (this.entity.WantedDateFrom) {
        this.wantedDates = {
          dateFrom: this.entity.WantedDateFrom,
          dateTo:
            this.entity.WantedDateTo &&
            this.entity.WantedDateTo != this.entity.WantedDateFrom
              ? this.entity.WantedDateTo
              : null,
        };
      } else {
        this.wantedDates = null;
      }
      this.ukraine = await getUkraine();
      this.entityLoaded = true;
    },

    async submit() {
      this.loadingSubmit = true;
      this.isChanged = false;
      const entityForSaving = {
        cargoComment: this.entity.CargoComment,
        packages:
          this.entity.Packages && this.entity.Packages.length
            ? this.entity.Packages.map(p => {
              return {
                packageTypeId: p.packageType.id,
                quantity: p.quantity,
                length: p.length,
                width: p.width,
                height: p.height,
              };
            })
            : [],
        clientAlias: this.entity.ClientAlias,
        clientId: this.entity.Client.id,
        commentForShipping: this.entity.CommentForShipping,
        countryId: this.entity.Country.id,
        currencyId: this.entity.Currency.id,
        destinationCountryId: this.entity.DestinationCountry.id,
        internalRequestNumber: this.entity.InternalRequestNumber,
        invoiceSum: this.entity.InvoiceSum,
        isPayed: this.entity.IsPayed,
        parseByOrders: this.entity.ParseByOrders,
        loadingAddressId: this.entity.LoadingAddress
          ? this.entity.LoadingAddress.id
          : null,
        contactsLoading:
          this.entity.ContactsLoading && this.entity.ContactsLoading.length
            ? this.entity.ContactsLoading.map(c => {
              return {
                id: c.id,
                contactPersonId: c.contactPerson.id,
                contactPhone: c.contactPhone,
                contactEmail: c.contactEmail,
              };
            })
            : [],
        loadingNumber: this.entity.LoadingNumber,
        loadingPlaceTimetable: this.entity.LoadingPlaceTimetable,
        managerId: this.entity.Manager.id,
        needExId: this.entity.NeedEx.id,
        oversized: this.entity.Oversized,
        packingMethod: this.entity.PackingMethod,
        readyDate: this.entity.ReadyDate,
        shippingTypeId: this.entity.ShippingType.id,
        unloadingAddressId: this.entity.UnloadingAddress.id,
        unloadingCityId: this.entity.UnloadingCity.id,
        contactsUnloading:
          this.entity.ContactsUnloading && this.entity.ContactsUnloading.length
            ? this.entity.ContactsUnloading.map(c => {
              return {
                id: c.id,
                contactPersonId: c.contactPerson.id,
                contactPhone: c.contactPhone,
              };
            })
            : [],
        unloadingCountryId: this.entity.UnloadingCountry.id,
        urgency: this.entity.Urgency,
        volume: this.entity.Volume,
        weight: this.entity.Weight,
        senderWarehouseId: this.entity.SenderWarehouse
          ? this.entity.SenderWarehouse.id
          : null,
        senderFactoryId: this.entity.SenderFactory
          ? this.entity.SenderFactory.id
          : null,
        senderAddressId: this.entity.SenderAddress
          ? this.entity.SenderAddress.id
          : null,
        productDescription: this.entity.ProductDescription,
        wantedDateFrom: this.wantedDates.dateFrom,
        wantedDateTo: this.wantedDates.dateTo
          ? this.wantedDates.dateTo
          : this.wantedDates.dateFrom,
        factoryClosingRequestDate: this.entity.FactoryClosingRequestDate,
        senderTypeId: this.senderType,
      };
      try {
        const shippingId = await newShippingApi.createShipping(entityForSaving);
        if (this.newAttachmentsForExport.length || this.newAttachments.length) {
          await this.saveAttachments(shippingId);
        }
        if (this.id && this.id > 0) {
          await newShippingApi.deleteShippingDraft(this.id);
        }
      } finally {
        this.loadingSubmit = false;
        this.showInfo("Поставка добавлена");
        this.$router.push({ name: "shippings" });
      }
    },
    async submitDraft() {
      this.loadingDraft = true;
      const entityForSaving = {
        cargoComment: this.entity.CargoComment,
        packages:
          this.entity.Packages && this.entity.Packages.length
            ? this.entity.Packages.map(p => {
              return {
                packageTypeId: p.packageType.id,
                quantity: p.quantity,
                length: p.length,
                width: p.width,
                height: p.height,
              };
            })
            : [],
        clientAlias: this.entity.ClientAlias,
        clientId: this.entity.Client ? this.entity.Client.id : null,
        commentForShipping: this.entity.CommentForShipping,
        countryId: this.entity.Country ? this.entity.Country.id : null,
        currencyId: this.entity.Currency ? this.entity.Currency.id : null,
        destinationCountryId: this.entity.DestinationCountry
          ? this.entity.DestinationCountry.id
          : null,
        internalRequestNumber: this.entity.InternalRequestNumber,
        invoiceSum: this.entity.InvoiceSum,
        isPayed: this.entity.IsPayed,
        parseByOrders: this.entity.ParseByOrders,
        loadingAddressId: this.entity.LoadingAddress
          ? this.entity.LoadingAddress.id
          : null,
        contactsLoading:
          this.entity.ContactsLoading && this.entity.ContactsLoading.length
            ? this.entity.ContactsLoading.map(c => {
              return {
                id: c.id,
                contactPersonId: c.contactPerson.id,
                contactPhone: c.contactPhone,
                contactEmail: c.contactEmail,
              };
            })
            : [],
        loadingNumber: this.entity.LoadingNumber,
        loadingPlaceTimetable: this.entity.LoadingPlaceTimetable,
        managerId: this.entity.Manager ? this.entity.Manager.id : null,
        needExId: this.entity.NeedEx ? this.entity.NeedEx.id : null,
        oversized: this.entity.Oversized,
        packingMethod: this.entity.PackingMethod,
        readyDate: this.entity.ReadyDate,
        shippingTypeId: this.entity.ShippingType.id,
        unloadingAddressId: this.entity.UnloadingAddress
          ? this.entity.UnloadingAddress.id
          : null,
        unloadingCityId: this.entity.UnloadingCity
          ? this.entity.UnloadingCity.id
          : null,
        contactsUnloading:
          this.entity.ContactsUnloading && this.entity.ContactsUnloading.length
            ? this.entity.ContactsUnloading.map(c => {
              return {
                id: c.id,
                contactPersonId: c.contactPerson.id,
                contactPhone: c.contactPhone,
              };
            })
            : [],
        unloadingCountryId: this.entity.UnloadingCountry
          ? this.entity.UnloadingCountry.id
          : null,
        urgency: this.entity.Urgency,
        volume: this.entity.Volume,
        weight: this.entity.Weight,
        senderType: this.senderType,
        senderWarehouseId: this.entity.SenderWarehouse
          ? this.entity.SenderWarehouse.id
          : null,
        senderFactoryId: this.entity.SenderFactory
          ? this.entity.SenderFactory.id
          : null,
        senderAddressId: this.entity.SenderAddress
          ? this.entity.SenderAddress.id
          : null,
        productDescription: this.entity.ProductDescription,
        wantedDateFrom: this.wantedDates ? this.wantedDates.dateFrom : null,
        wantedDateTo: this.wantedDates
          ? this.wantedDates.dateTo
            ? this.wantedDates.dateTo
            : this.wantedDates.dateFrom
          : null,
        factoryClosingRequestDate: this.entity.FactoryClosingRequestDate,
      };
      try {
        if (this.id) {
          await newShippingApi.updateShippingDraft(this.id, entityForSaving);
          if (
            this.newAttachmentsForExport.length ||
            this.newAttachments.length
          ) {
            await this.saveAttachments(this.id, true);
          }
        } else {
          const res = await newShippingApi.createShippingDraft(entityForSaving);
          if (
            this.newAttachmentsForExport.length ||
            this.newAttachments.length
          ) {
            await this.saveAttachments(res, true);
          }
        }
      } finally {
        this.isChanged = false;
        this.loadingDraft = false;
        this.showInfo("Черновик сохранен");
        this.$router.push({ name: "shipping-drafts" });
      }
    },
    async deleteDraft() {
      if (
        confirm(
          "Восстановление черновика невозможно. Вы действительно хотите удалить черновик?",
        )
      ) {
        this.loadingDeleteDraft = true;
        await newShippingApi.deleteShippingDraft(this.id);
        this.loadingDeleteDraft = false;
        this.showInfo("Черновик поставки удален");
        this.suppressLeaveConfirm = true;
        this.$router.go(-1);
      }
    },
    cancel() {
      this.$router.go(-1);
    },
    handleEntityChange() {
      this.isChanged = this.isEntityReallyChanged(
        this.originEntity,
        this.entity,
      );
    },
    isEntityReallyChanged(origin, current) {
      if (!origin) {
        return true;
      } else {
        let isChanged = false;
        for (const property in origin) {
          if (typeof current[property] === "object") {
            isChanged =
              current[property] && origin[property]
                ? origin[property].id !== current[property].id
                : true;
          } else {
            isChanged =
              origin[property].toString() !== current[property].toString();
          }
          if (isChanged) {
            return true;
          }
        }
      }
      return false;
    },
    async clientChanged() {
      if (!this.entity.Client) {
        this.entity.Employee = null;
        this.entity.ClientAlias = null;
        this.entity.Manager = null;
        return;
      }
      this.clientLoading = true;
      const manager = await clientsApi.getClientManager(this.entity.Client.id);
      this.entity.Manager = manager;
      this.clientLoading = false;
    },
    getMask(controlType) {
      switch (controlType) {
        case "phone":
          return "+##(###)###-##-##";
        case "number":
          return "##########";
        case "isoCodeAlpha3":
          return "AAA";
        default:
          return "";
      }
    },
    async saveAttachments(id, draft) {
      const items = this.newAttachmentsForExport
        .concat(this.newAttachments)
        .map(a => {
          return {
            id: a.id || 0,
            originName: a.title,
            type: a.type,
            data: a.data,
          };
        });
      await newShippingApi.createAttachments(id, items, draft);
    },
    clearLoadingAdditionalFields() {
      this.entity.LoadingContactPerson = null;
      this.entity.LoadingPlaceTimetable = "";
      this.entity.ContactPhone = "";
      this.entity.ContactEmail = "";
    },
    async saveNewClientAlias(items) {
      await newShippingApi.updateNewClientAlias(
        this.entity.Client.id,
        this.newClientAlias,
      );
      this.entity.ClientAlias = this.newClientAlias;
      items.push({ value: this.newClientAlias, text: this.newClientAlias });
      this.$refs["client-alias"].$children[0].blur();
      this.newClientAlias = "";
    },
    unloadingContactsChanged(contactsUnloading) {
      this.entity.ContactsUnloading = [];
      this.$set(this.entity, "ContactsUnloading", contactsUnloading);
      this.handleEntityChange();
    },
    emailChange(value) {
      return value;
    },
    shippingTypeChanged() {
      this.handleEntityChange();

      if (
        this.entity.ShippingType &&
        (this.entity.ShippingType.id === shippingTypes.ImportUkraine ||
          this.entity.ShippingType.id === shippingTypes.InsideUkraine)
      ) {
        this.$set(this.entity, "UnloadingCountry", {
          id: this.ukraine.Id,
          title: this.ukraine.Title,
        });
      }

      if (
        this.countryWithoutUkraine &&
        this.entity.UnloadingCountry &&
        this.entity.UnloadingCountry.id === this.ukraine.Id
      ) {
        this.$set(this.entity, "UnloadingCountry", null);
      }
    },
    async unloadingAddressChanged() {
      if (!this.entity.UnloadingAddress) {
        return;
      }
      const res = await getWarehouseReferenceAddress(
        this.entity.UnloadingAddress.id,
      );
      this.isOurWarehouse = res.data ? res.data.OurWarehouse : false;
    },
    changeStep(val) {
      this.stepper = val;
    },
    showFileUploader() {
      if (this.newAttachments.length <= 0) {
        upload().then(
          files => (this.newAttachments = this.newAttachments.concat(files)),
        );
      } else {
        this.attachmentDialog = true;
      }
    },
    checkValidWantedDate() {
      if (!this.isAfterReadyDate) {
        return;
      }
      this.error = this.isAfterReadyDate === true ? false : true;
    },
    unloadingCountryChanged() {
      this.entity.UnloadingCity = "";
      this.entity.UnloadingAddress = "";
    },
    async getNewShippingUkr() {
      const response = await newShippingApi.getNewShippingUkr();
      if (response) {
        this.$set(this.entity, "UnloadingCountry", response);
      } else {
        this.$set(this.entity, "UnloadingCountry", null);
      }
    },
    checkMissingElement(value, required) {
      if (!value && !required) {
        return "label-color";
      }
      if (!value && required) {
        return true;
      }
    },
    checkMissingVolume(value, required) {
      if (!value && !required) {
        return "label-color";
      }
      if (value == null && required) {
        return true;
      }
    },
    changePackages(value) {
      this.entity.Packages = value;
      if (
        this.entity.Packages.find(
          i => i.width > 2.4 || i.height > 2.4 || i.length > 2.4,
        )
      ) {
        this.entity.Oversized = true;
      } else {
        this.entity.Oversized = false;
      }
      this.handleEntityChange();
    },
    changeAttachmentsForExport(value) {
      if (this.isDraft) {
        return this.newAttachmentsForExport.concat(value);
      } else {
        this.newAttachmentsForExport.concat(
          value.forEach(a => {
            a.id = 0;
            a.title = a.sourceName;
          }),
        );
      }
    },
    changeAttachments(value) {
      if (this.isDraft) {
        return this.newAttachmentsForExport.concat(value);
      } else {
        this.newAttachments.concat(
          value.forEach(a => {
            a.id = 0;
            a.title = a.sourceName;
          }),
        );
      }
    },
    senderTypeChanged() {
      this.entity.SenderWarehouse = null;
      this.entity.SenderAddress = null;
      this.entity.LoadingPlace = null;
      this.entity.LoadingAddress = null;
      this.isChangedSenderType = true;
    },
  },
};
</script>

<style>
.stepper-title {
  color: #1976d2;
}
.v-card__text .layout .v-input--selection-controls.v-input .v-label {
  height: 20px;
}
.label-color .v-text-field__slot {
  color: #ef5350;
}
.label-color .theme--light.v-label {
  color: inherit;
}
</style>
